var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStVincentAndTheGrenadines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5653 2.4318C26.7238 0.881484 23.4649 0 20.0001 0C16.5352 0 13.2763 0.881484 10.4348 2.4318L8.69571 20L10.4348 37.5682C13.2763 39.1185 16.5352 40 20.0001 40C23.4649 40 26.7238 39.1185 29.5653 37.5682L31.3045 20L29.5653 2.4318Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 37.568V2.43164C4.21794 5.82383 4.57764e-05 12.4191 4.57764e-05 19.9999C4.57764e-05 27.5808 4.21794 34.176 10.4348 37.568Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 19.9999C40 12.4191 35.7821 5.82383 29.5652 2.43164V37.568C35.7821 34.176 40 27.5808 40 19.9999V19.9999Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 25.2174L12.1739 20L15.6522 14.7826L19.1306 20L15.6523 25.2174Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3479 25.2174L20.8696 20L24.3479 14.7826L27.8262 20L24.3479 25.2174Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 32.1739L16.5218 26.9565L20 21.7391L23.4783 26.9565L20 32.1739Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStVincentAndTheGrenadines);
export default __webpack_public_path__ + "static/media/st_vincent_and_the_grenadines.5a4930bc434f97c5f0613603cb9b571b.svg";
export { ForwardRef as ReactComponent };